import VouchersReport from "./VouchersReport";

export default VouchersReport;
